import React from "react";

import "../../../../styles/css/App.css";

import { Grid } from "@material-ui/core";
import InfiniteScroll from 'react-infinite-scroller';
import CircularProgress from '@mui/material/CircularProgress';
import { withRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useMediaQuery } from 'react-responsive';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import ArchiveRoundedIcon from '@mui/icons-material/ArchiveRounded';
import TextField from '@mui/material/TextField';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import UpdateRoundedIcon from '@mui/icons-material/UpdateRounded';
import * as Constants from "../../../../consts/Constants.js";

import alerter from "../../../alerts/alerter";
import AdvertisementItem from "./advertisement-item"
import AdForm from "../form";
import AdView from "../view";
import Pager from "../../../utils/pager";
import { Advertisement } from '../../../../plas/services/ads/models';

import service from '../../../../plas/services/ads/service';

function CultureAds({ history }) {
  
  const theme = createTheme({
    palette: {
      primary: {
        main: '#FFFFFF',
        darker: '#FFFFFF',
      }
    },
  });

  const isMedium = useMediaQuery({ query: `(max-width: 900px)` });

  const pager = React.useRef(new Pager(5));
  const firstTime = React.useRef(false);

  const [items, setItems] = React.useState([]);
  const [moreItems, setMoreItems] = React.useState(true);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [openDetails, setOpenDetails] = React.useState(false);
  const [selectedAdvertisement, setSelectedAdvertisement] = React.useState(null);
  const [updating, setUpdating] = React.useState(null);
  const [selectedState, setSelectedState] = React.useState(0);
  const [searchTerm, setSearchTerm] = React.useState(null)

  React.useEffect(() => {
    let delayDebounceFn = null;
    if (firstTime.current) {
      delayDebounceFn = setTimeout(() => {
        resetSearch();
      }, 250)
    } else {
      firstTime.current = true
    }
    return () => {
      clearTimeout(delayDebounceFn)
    }
  }, [searchTerm])

  const edit = (advertisement) => {
    setSelectedAdvertisement(new Advertisement({...advertisement}));
    setOpenDialog(true)
  }

  const create = () => {
    let advertisement = new Advertisement();

    let state = selectedState;
    if (state < 0) // Por si seleccionaron del pasado
      state = 0;

    advertisement.categoryId = 1; // ID de categoría cultura
    advertisement.state = state;
    setSelectedAdvertisement(advertisement);
    setOpenDialog(true)
  }

  const update = (advertisement, newState) => {
    let aux = { ...advertisement }
    aux.state = newState
    setUpdating(advertisement.id);
    service.api.advertisements.update(aux, (response) => {
      if (response.result != null) {
        let newItems = items.filter((item) => item.id !== advertisement.id)
        setItems(newItems);  
      } else {
        alerter.showError(response.error);
      }
      setUpdating(null);
    });
  }

  const open = (advertisement) => {
    setSelectedAdvertisement(advertisement);
    setOpenDetails(true);
  }

  const archive = (advertisement) => {
    update(advertisement, 1)
  }

  const unarchive = (advertisement) => {
    update(advertisement, 0);
  }

  const remove = (advertisement) => {
    update(advertisement, 2);
  }

  const changeState = (newValue) => {
    if (newValue !== selectedState) {
      setSelectedState(newValue);
      resetSearch();
    }
  }

  const cancel = () => {
    setOpenDialog(false);
  }

  const cancelDetails = () => {
    setOpenDetails(false);
  }

  const saved = () => {
    cancel()
    alerter.showSuccess("Se guardaron los cambios del aviso.")
    resetSearch()
  }

  const getNextPage = () => {
    let page = pager.current.getNextPage();

    let now = new Date();

    let state = selectedState;
    if (state < 0) // Por si seleccionaron del pasado
      state = 0;

    let startDate = selectedState === 0 ? now.getTime() : 0;
    let endDate = selectedState === -1 ? now.getTime() : null;
    let order = selectedState === 0 ? "+endDate" : "-endDate";

    service.api.advertisements.getByCategory("culture",page.startItem,page.endItem,searchTerm,startDate,endDate,order,state,(response) => {
      if (response.result != null) {
        pager.current.update(response.result.data.length, response.result.total)
        setMoreItems(!pager.current.ended);
        setItems([...items, ...response.result.data])  
      } else {
        alerter.showError(response.error);
        setMoreItems(false);
      }
    });
  }

  const changeSearch = (e) => {
    let term = e.target.value.trim();
    if (!term)
      setSearchTerm(null);
    else
      setSearchTerm(term);  
  }

  const resetSearch = () => {
    pager.current.reset();
    setItems([]);
    setMoreItems(true);
  }

  const ColoredLine = ({ color, marginTop, marginBottom }) => (
      <hr
        style={{
          color: color,
          backgroundColor: color,
          marginTop: marginTop !== undefined ? marginTop : 6,
          marginBottom: marginBottom !== undefined ? marginBottom : 16,
          height: 2
        }}
      />
  );

  return (
    <div>
      <Grid container spacing={2} >
        <Grid item xs={false} md={2} />
        <Grid item xs={12} md={8} >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={true}>
                  <p style={{ fontSize: '28px', textAlign: 'left'}}>
                    Cartelera cultural
                  </p>
                </Grid>
                <Grid item>
                  { service.canAdminCulture() && (
                  <ThemeProvider theme={theme}>
                    <Button
                      startIcon={<AddRoundedIcon />}
                      variant="contained"
                      onClick={create}>
                      <b>Agregar</b>
                    </Button>
                  </ThemeProvider>
                  )}
                </Grid>
              </Grid>
              <ColoredLine color="gray" marginTop={0} marginBottom={0} />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={true}>
                  <TextField 
                    label="Buscar" 
                    size="small" 
                    fullWidth 
                    variant="outlined" 
                    onChange={changeSearch}/>
                </Grid>
                <Grid item xs={false} sm={2}>
                </Grid>
                <Grid item>
                 <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"> 
                    <Stack direction="row" spacing={1}>
                      <Chip color="default" icon={<UpdateRoundedIcon/>} label="Próximas" component="a" clickable variant={selectedState === 0 ? "filled" : "outlined" } onClick={() => changeState(0)}/>
                      <Chip color="default" icon={<HistoryRoundedIcon/>} label="Pasadas" component="a" clickable variant={selectedState === -1 ? "filled" : "outlined" } onClick={() => changeState(-1)}/>
                      { service.canAdminCulture() && (<Chip color="default" icon={<ArchiveRoundedIcon/>} label="Archivadas" component="a" clickable variant={selectedState === 1 ? "filled" : "outlined"} onClick={() => changeState(1)}/>) }
                    </Stack>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <div >
                <InfiniteScroll
                  pageStart={0}
                  loadMore={getNextPage}
                  hasMore={moreItems}
                  loader={<CircularProgress key={-1} size={32} style={{color:Constants.COLOR_PRIMARY, padding: 2}} color="inherit" />}>
                  {items.map((item, index) =>( 
                    <Grid key={item.id} container>
                      <Grid item xs={true}>
                        <AdvertisementItem key={index} advertisement={item} canEdit={service.canAdminCulture()} onEdit={edit} onArchive={archive} onUnarchive={unarchive} onDelete={remove} disable={updating != null} updating={updating === item.id} onOpen={open} />
                      </Grid>
                    </Grid>
                  ))}
                </InfiniteScroll>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={false} md={2} />
      </Grid>
      <Dialog open={openDialog} fullWidth maxWidth="lg" fullScreen={isMedium}>
        <DialogContent style={{ paddingTop: '16px', paddingBottom: '16px' }}>
          <AdForm fullWidth initialAdvertisement={selectedAdvertisement} onCancel={cancel} onSave={saved}/>
        </DialogContent>
      </Dialog>

      <Dialog open={openDetails} fullWidth maxWidth="lg" fullScreen={isMedium}>
        <DialogContent style={{ paddingTop: '16px', paddingBottom: '16px' }}>
          <AdView fullWidth advertisement={selectedAdvertisement} onClose={cancelDetails}/>
        </DialogContent>
      </Dialog>
    </div>
  );

}

export default withRouter(CultureAds);
